import styles from "./ActiveFilterTags.module.css"
import { getActiveFilterTags } from "./filterConstants.js"
import type { Filters } from "./useBenefits.js"

interface Props {
  filters: Filters
  onChange: (partial: Partial<Filters>) => void
}

export function ActiveFilterTags({ filters, onChange }: Props) {
  const tags = getActiveFilterTags(filters)
  if (tags.length === 0) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.scroll}>
        {tags.map((tag) => (
          <button
            key={tag.id}
            type="button"
            className={styles.tag}
            onClick={() => onChange(tag.remove)}
            aria-label={`${tag.label} を解除`}
          >
            <span>{tag.label}</span>
            <span className={styles.remove} aria-hidden="true">
              ×
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}
